
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"13","height":"6","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.733 2.683a6.104 6.104 0 00-4.025-1.516 6.12 6.12 0 00-5.81 4.211l1.377.455a4.668 4.668 0 014.433-3.208c1.138 0 2.176.42 2.987 1.097L7.583 5.833h5.25V.583l-2.1 2.1z","fill":"#000"}})])
          )
        }
      }
    